// The download buttons are "Download for Mac" in the HTML (what crawlers and pages without JavaScript get). /api/latest
// adds the version, or turns them into "Coming soon" when it answers that there is no release; when it can't be reached
// they stay as they are (shared/release.ts has the fields and the version check the Worker uses too).
import { downloadHref } from '../shared/analytics.ts';
import { isAvailable, type Latest } from '../shared/release.ts';

export function render(latest: Latest | null): void {
  const ready = isAvailable(latest);
  for (const a of document.querySelectorAll<HTMLAnchorElement>('[data-download]')) {
    const label = a.querySelector('[data-download-label]');
    const meta = a.querySelector('[data-download-meta]');
    a.dataset.state = ready ? 'ready' : 'soon';
    if (ready) {
      a.setAttribute('href', downloadHref(location.search, document.referrer));
      a.removeAttribute('aria-disabled');
      if (label) label.textContent = 'Download for Mac';
      if (meta) meta.textContent = `v${latest.version} · Apple Silicon`;
    } else {
      a.removeAttribute('href');
      a.setAttribute('aria-disabled', 'true');
      if (label) label.textContent = 'Coming soon';
      if (meta) meta.textContent = 'for Apple Silicon Macs';
    }
  }
  const status = document.querySelector('[data-download-status]');
  if (status) status.textContent = ready ? '' : 'The first release isn’t out yet.';
}

export function initDownload(): void {
  // The download is counted with where this visitor came from (shared/analytics.ts).
  for (const a of document.querySelectorAll<HTMLAnchorElement>('[data-download][href]')) a.setAttribute('href', downloadHref(location.search, document.referrer));
  const ctl = new AbortController();
  const timer = window.setTimeout(() => ctl.abort(), 4000);
  fetch('/api/latest', { headers: { accept: 'application/json' }, signal: ctl.signal })
    .then((r) => (r.ok ? (r.json() as Promise<Latest>) : undefined))
    .catch(() => undefined)
    .then((latest) => latest !== undefined && render(latest))
    .finally(() => window.clearTimeout(timer));
}
